module.exports = __webpack_public_path__ + "img/img3.93f0ee76.png";